import store from "@/store"

async function handleLogInEvent() {}

async function handleLogOutEvent() {
  if (!store.getters["timezone/timezoneOverwrite"]) return

  try {
    await store.dispatch("timezone/resetTimezone")
  } catch (e) {
    console.error(`Timezone module failed to handle logout event - upstream exception: ${e}`)
  }
}

export default {
  handleLogInEvent,
  handleLogOutEvent
}
